import { axiosUtils } from "../../../../network/axiosUtils";
import httpRequest from "../../../../network/httpRequest";
import { HttpResponse } from "../../../../network/types";
import { SearchAddressType } from "../types";
import { Address } from "../../../../model/Address";
import { ListResponse } from "../../../../model/common/ListResponse";

export const searchAddress = async (
  searchInputData: SearchAddressType
): Promise<ListResponse<Address>> => {
  const method = axiosUtils.GET;
  const url = "/addresses";
  const response: HttpResponse = await httpRequest({
    method,
    url,
    queryParams: searchInputData,
  });
  return { rows: response?.data.rows, count: response?.data.count };
};
